// extracted by mini-css-extract-plugin
export var description = "Topic-module--description--eaf81";
export var icon = "Topic-module--icon--6e4b3";
export var sections = "Topic-module--sections--dabde";